import { Fragment, useEffect, useState } from 'react';

import { ProductService as Service, StampService } from './ProductService';
import { UnitService } from '../don-vi-tinh/UnitService';
import { TaxService } from '../thue-suat/TaxService';
import { PartnerService } from '../doi-tac/PartnerService';
import { GroupProductService } from '../nhom-san-pham/GroupProductService';
import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';
import { useImExExcel } from '../../../shared/hooks/ImExExcel';
import { FormatDisplay } from '../../../shared/format';
import { ConfirmDialogService } from '../../../AppConfirmDialog';
import { useDialogChangeTax } from './item/DialogChangeTax';
import EventEmitter from '../../../utils/EventEmitter';
import { Sign, useSign } from '../../../shared/component/Sign';
import { AppStorage } from '../../../service/UserStorage';
import { useImZip } from '../../../shared/hooks/ImZip';
export const List = () => {

  const header = 'Hàng hóa, dịch vụ';
  const dataKey = 'id';
  const [displaySelectProduct, setDisplaySelectProduct] = useState(null);
  const [units, setUnits] = useState([]);
  const [partners, setPartners] = useState([]);
  const [manyActions, setManyActions] = useState([]);
  const [taxs, setTaxs] = useState([]);
  const [productsChange, setProductsChange] = useState([]);
  const [groupProducts, setGroupProduct] = useState([]);
  useEffect(() => {
    UnitService.getList({
      skipCount: 0,
      maxResultCount: 1000,
    }).then(({ items }) => {
      const _units = [];
      items.forEach(item => {
        _units.push({ value: item.id, label: item.name });
      });
      setUnits(_units);
    });
    TaxService.getAll().then((items) => {
      const _taxs = [];
      items.forEach((item) => {
        _taxs.push({ value: item.id, label: item.name });
      });
      setTaxs(_taxs);
    });
    PartnerService.getAll().then((items) => {
      const _partners = [];
      items.forEach((item) => {
        _partners.push({ value: item.id, label: item.name });
      });
      setPartners(_partners);
    });
    GroupProductService.getAll().then((items) => {
      const _groupProducts = [];
      items.forEach((item) => {
        _groupProducts.push({ value: item.id, label: item.name });
      });
      setGroupProduct(_groupProducts);
    });

  }, []);
  console.log("ProductService");


  useEffect(() => {
    const eventsChangeSerial = EventEmitter.addListener("changeTaxs", changeTaxs);
    return () => {
      eventsChangeSerial.removeListener("changeTaxs", changeTaxs);
    }
  });

  const changeTaxs = (changeTaxsData) => {
    Service.updateChangeTax(changeTaxsData).then(res => {
      refreshLazyData();
    });
  }

  const { render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems, dataTableParams } = useDataTable({
    header,
    dataKey,
    columns: JSON.parse(AppStorage.get('tenantInfo'))?.companyType === '01' ? [
      {
        field: 'print', header: 'In tem', width: 70, sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return <i className="pi pi-print" onClick={() => print(rowData)}></i>
        }, style: { justifyContent: 'center' }
      }, {
        field: 'groupId', header: 'Nhóm hàng hóa', width: 160, matchMode: 'contains', filterType: 'multiselect', filterOptions: groupProducts, dataType: 'custom', customCell(rowData: any): any {
          return rowData.groupName;
        }
      },
      { field: 'code', header: 'Mã hàng hóa', width: 200, matchMode: 'contains' },
      { field: 'name', header: 'Tên hàng hóa', minWidth: 220, matchMode: 'contains' },
      {
        field: 'totalWeight', header: 'Trọng lượng', width: 160, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return FormatDisplay.number(rowData.totalWeight, { maximumSignificantDigits: `${rowData.totalWeight}`.length })
        }, style: { justifyContent: 'end' }
      },
      {
        field: 'weightOther', header: 'Trọng lượng đá', width: 160, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return FormatDisplay.number(rowData.weightOther, { maximumSignificantDigits: `${rowData.weightOther}`.length })
        }, style: { justifyContent: 'end' }
      },
      {
        field: 'price', header: 'Đơn giá', width: 160, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return FormatDisplay.number(rowData.price, { maximumSignificantDigits: `${rowData.price}`.length })
        }, style: { justifyContent: 'end' }
      },
      {
        field: 'wage', header: 'Tiền công', width: 160, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return FormatDisplay.number(rowData.wage, { maximumSignificantDigits: `${rowData.wage}`.length })
        }, style: { justifyContent: 'end' }
      },
      {
        field: 'taxId', header: 'Thuế suất', width: 160, matchMode: 'contains', filterType: 'multiselect', filterOptions: taxs, dataType: 'custom', customCell(rowData: any): any {
          return rowData.taxName;
        }
      },
      { field: 'unit', header: 'Đơn vị tính', width: 160, matchMode: 'contains' },
      {
        field: 'partnerId', header: 'Nhà cung câp', width: 160, matchMode: 'contains', filterType: 'multiselect', filterOptions: partners, dataType: 'custom', customCell(rowData: any): any {
          return rowData.partnerName;
        }
      },
    ] :
      [
        {
          field: 'groupId', header: 'Nhóm hàng hóa', width: 160, matchMode: 'contains', filterType: 'multiselect', filterOptions: groupProducts, dataType: 'custom', customCell(rowData: any): any {
            return rowData.groupName;
          }
        },
        { field: 'code', header: 'Mã hàng hóa', width: 200, matchMode: 'contains' },
        { field: 'name', header: 'Tên hàng hóa', minWidth: 220, matchMode: 'contains' },
        {
          field: 'price', header: 'Đơn giá', width: 160, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
            return FormatDisplay.number(rowData.price, { maximumSignificantDigits: `${rowData.price}`.length })
          }, style: { justifyContent: 'end' }
        },
        {
          field: 'taxId', header: 'Thuế suất', width: 160, matchMode: 'contains', filterType: 'multiselect', filterOptions: taxs, dataType: 'custom', customCell(rowData: any): any {
            return rowData.taxName;
          }
        },
        { field: 'unit', header: 'Đơn vị tính', width: 160, matchMode: 'contains' },
        {
          field: 'partnerId', header: 'Nhà cung câp', width: 160, matchMode: 'contains', filterType: 'multiselect', filterOptions: partners, dataType: 'custom', customCell(rowData: any): any {
            return rowData.partnerName;
          }
        },
      ]
    ,
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });
  const { render: renderDialogCrup, create, update, clone, getValue, setValue, touched } = useDialogCrup({
    header,
    dataKey,
    width: '60rem',
    fields: JSON.parse(AppStorage.get('tenantInfo'))?.companyType === '01' ? [
      { field: 'groupId', header: 'Nhóm hàng hóa', required: true, type: 'Dropdown', DropdownProps: { options: groupProducts, filter: true }, className: 'md:col-6' },
      { field: 'productProperty', header: 'Là vàng bạc', type: 'Checkbox', className: 'md:col-6 flex align-items-end' },
      { field: 'code', header: 'Mã hàng hóa', required: true, uppercase: true, InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'name', header: 'Tên hàng hóa', required: true, InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'totalWeight', header: 'Trọng lượng', type: 'InputNumber', InputNumberProps: { min: 0, maxFractionDigits: 6 }, className: 'md:col-6' },
      { field: 'weightOther', header: 'Trọng lượng đá', type: 'InputNumber', InputNumberProps: { min: 0, maxFractionDigits: 6 }, className: 'md:col-6' },
      { field: 'price', header: 'Đơn giá', type: 'InputNumber', InputNumberProps: { min: 0, maxFractionDigits: 6 }, className: 'md:col-6' },
      { field: 'wage', header: 'Tiền công', type: 'InputNumber', InputNumberProps: { min: 0, maxFractionDigits: 6 }, className: 'md:col-6' },
      { field: 'unitId', header: 'Đơn vị tính', type: 'Dropdown', DropdownProps: { options: units, filter: true }, className: 'md:col-6' },
      { field: 'taxId', header: 'Thuế suất', type: 'Dropdown', DropdownProps: { options: taxs, filter: true }, className: 'md:col-6' },
      { field: 'partnerId', header: 'Nhà cung cấp', type: 'Dropdown', DropdownProps: { options: partners, filter: true }, className: 'md:col-6' },
    ] : [

      { field: 'code', header: 'Mã hàng hóa', required: true, uppercase: true, InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'name', header: 'Tên hàng hóa', required: true, InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'price', header: 'Đơn giá', type: 'InputNumber', InputNumberProps: { min: 0, maxFractionDigits: 6 }, className: 'md:col-6' },
      { field: 'unitId', header: 'Đơn vị tính', type: 'Dropdown', DropdownProps: { options: units, filter: true }, className: 'md:col-6' },
      { field: 'taxId', header: 'Thuế suất', required: JSON.parse(AppStorage.get('tenantInfo'))?.companyType === '03', type: 'Dropdown', DropdownProps: { options: taxs, filter: true }, className: 'md:col-6' },
      { field: 'partnerId', header: 'Nhà cung cấp', type: 'Dropdown', DropdownProps: { options: partners, filter: true }, className: 'md:col-6' },
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const { renderImExExcel, download, showImportDialog } = useImExExcel({
    exportTemplate: () => {
      return Service.downloadExcelTemplate();
    },
    exportExcel: (params) => {
      return Service.downloadExcel(params);
    },
    exportExcelFileName: 'danh-muc-hang-hoa-dich-vu',
    importExcel: (data) => {
      return Service.uploadExcel(data);
    },
    reloadLazyData
  });

  const { renderImZip, showImportDialogZip } = useImZip({

    importZip: (data) => {
      return StampService.uploadTemplate(data);
    },
    reloadLazyData
  });

  const { renderToolbar, refreshToolbar } = useToolbar({
    dataKey, create,
    update: (item) => {
      Service.get(item[dataKey]).then(data => {
        update(data);
      });
    },
    clone: (item) => {
      Service.get(item[dataKey]).then(data => {
        clone(data);
      });
    },
    reloadLazyData, selectedItems,
    showImportDialog,
    exportExcel: download, dataTableParams,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    otherActions: [
      { label: 'Nhập file tem', icon: 'pi pi-arrow-up', className: 'iam-toolbar iam-toolbar-secondary', command: showImportDialogZip },
    ]
  });

  const onAddSelectedItems = (items) => {
    let InvoiceIdArray;
    if (Array.isArray(items) && items.length) {
      InvoiceIdArray = items.map(({ id }) => id);
    }

    if (!InvoiceIdArray || InvoiceIdArray.length < 1) {
      ConfirmDialogService.showInvalid('Bạn cần chọn hàng hóa trước khi sửa');
      return;
    }

    // sign({
    //  "CommandName": "SignInvoices",
    //  "InvoiceIdArray": InvoiceIdArray
    // });
  }

  const { renderChangeTax, showChangeTaxDialog } = useDialogChangeTax({
    selectedItems,
    taxs
  });

  const print = (rowData) => {
    let tenantInfoString = AppStorage.get('tenantInfo');
    let accessTokenString = AppStorage.get('access_token');
    let tenantIncache = JSON.parse(tenantInfoString) || {};
    Sign({
      ...rowData,
      companyName: tenantIncache.nameShort,
      address: tenantIncache.addressShort,
      accessToken: accessTokenString,
      taxCode: tenantIncache.taxCode,
    }).then(() => {
      refreshLazyData();
    });
  }
  const { groupId, price } = getValue();
  useEffect(() => {
    if (touched) {
      const _value = getValue();
      _value.price = 0;
      if (price > 0) {
        _value.price = price;
      }
      setValue(_value);
    }
  }, [groupId, price]);
  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
      {renderImExExcel()}
      {renderImZip()}
      {renderChangeTax()}
    </Fragment>
  )
}
